// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const StudentRewardType = {
  Quest: 'Quest',
} as const
export type StudentRewardType =
  (typeof StudentRewardType)[keyof typeof StudentRewardType]

export function StudentRewardTypeFromJSON(json: any): StudentRewardType {
  return StudentRewardTypeFromJSONTyped(json, false)
}

export function StudentRewardTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): StudentRewardType {
  return json as StudentRewardType
}

export function StudentRewardTypeToJSON(value?: StudentRewardType | null): any {
  return value as any
}
